import api from './client';

export interface ActivityItem {
  resource_type: 'architecture' | 'project';
  resource_id: string;
  accessed_at: string;
  name: string;
  provider?: string;
  project_name?: string;
  project_id?: string;
}

/** Enregistre une consultation (fire & forget — ne pas await dans les composants) */
export async function logActivity(resource_type: 'architecture' | 'project', resource_id: string): Promise<void> {
  try {
    await api.post('/api/activity', { resource_type, resource_id });
  } catch {
    // silencieux — le tracking ne doit jamais bloquer l'UX
  }
}

/** Récupère les ressources récemment consultées par l'utilisateur courant */
export async function getRecentActivity(limit = 20): Promise<ActivityItem[]> {
  const response = await api.get(`/api/activity/recent?limit=${limit}`);
  return response.data.items || [];
}
